// extracted by mini-css-extract-plugin
export default {"menu":"TableMenu_menu__p2YEC","list":"TableMenu_list__y3HHJ","headerIcon":"TableMenu_headerIcon__5fUSZ","headerIcon_active":"TableMenu_headerIcon_active__+eFvH"};